import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Col, Row } from "~/components/elements";
import { BaseLayout } from "~/components/layouts";
import { PAGES } from "~/constants";
import { useAppSelector } from "~/hooks";
import authBg from "~/assets/img/v2/auth_bg_1.jpg";

interface Props {
  children: React.ReactNode;
}

export function AuthLayout({ children }: Props) {
  const history = useHistory();
  const currentUser = useAppSelector(state => state.auth.currentUser);

  useEffect(() => {
    if (currentUser?.id) {
      history.push(PAGES.DASHBOARD);
    }
  }, [currentUser, history]);

  return (
    <BaseLayout>
      <Row minH="100dvh" h="full" bgColor="#FFFFFF80">
        <Col flex={3} justifyContent={{ base: "flex-start", md: "center" }}>
          {children}
        </Col>
        <Col
          hideBelow="xl"
          flex={4}
          h="100dvh"
          w="full"
          backgroundImage={authBg}
          backgroundSize="cover"
          backgroundRepeat="no-repeat"
        />
      </Row>
    </BaseLayout>
  );
}
